import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=7b5668a5&"
import script from "./TermsConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsConditions.vue?vue&type=script&lang=ts&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=7b5668a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports